import { Form, FormikErrors, FormikProps, FormikTouched } from "formik";
import React from "react";
import ProgressBar from "../../DonateForm/Components/ProgressBar";
import ErrorMessage from "../../GenericForm/Components/ErrorMessage";
import "../Style/WaForm.scss";
import "../Style/WaMembershipForm.scss";
import { IWaMemberShipFormModel, MembershipFormType } from "./Constants";
import { IWaMembershipFormProps } from "./WaMembershipForm";
import { useWaMembershipFormContext } from "./WaMembershipFormContext";
import WaMembershipFormStep0, { getStepZeroFields } from "./WaMembershipFormStep0";
import WaMembershipFormStep1, { stepOneFields } from "./WaMembershipFormStep1";
import WaMembershipFormStep2, { stepTwoFields } from "./WaMembershipFormStep2";
import WaMembershipFormStep3 from "./WaMembershipFormStep3";
import LoadingOverlay from "react-loading-overlay";
import { ClipLoader } from "react-spinners";
import ThankYouStep from "./ThankYouStep";

const continueOnClick = (
	errors: FormikErrors<IWaMemberShipFormModel>,
	touched: FormikTouched<IWaMemberShipFormModel>,
	values: IWaMemberShipFormModel,
	setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void,
	stepNum: number,
	setStepNum: (step: number) => void,
	formType: string
) => {
	if (
		stepNum === 0 &&
		!getStepZeroFields(formType).some((field) => errors[field]) &&
		getStepZeroFields(formType).every((field) => touched[field])
	) {
		setStepNum(stepNum + 1);
	} else if (
		stepNum === 1 &&
		!stepOneFields.some((field) => errors[field]) &&
		stepOneFields.every((field) => touched[field])
	) {
		setStepNum(stepNum + 1);
	} else if (
		stepNum === 2 &&
		!stepTwoFields.some((field) => errors[field]) &&
		stepTwoFields.every((field) => touched[field])
	) {
		setStepNum(stepNum + 1);
	} else {
		if (stepNum === 0) {
			getStepZeroFields(formType).forEach((field) => {
				setFieldTouched(field, true, true);
			});
		}
		if (stepNum === 1) {
			stepOneFields.forEach((field) => {
				setFieldTouched(field, true, true);
			});
		}
		if (stepNum === 2) {
			stepTwoFields.forEach((field) => {
				setFieldTouched(field, true, true);
			});
		}
	}
};

export const InnerForm: React.FC<IWaMembershipFormProps & FormikProps<IWaMemberShipFormModel>> = (
	props
) => {
	const formContext = useWaMembershipFormContext();

	return (
		<LoadingOverlay
			active={formContext.busyState.isBusy}
			className={"loadingOverlay"}
			spinner={<ClipLoader sizeUnit={"px"} size={200} color={"white"} />}
		>
			<Form>
				<div className={"donGradient donForm " + formContext.colorTheme}>
					<div className="contentWrapper">
						<div className="formLeftSide">
							<div>
								<div className="rootContainerThing">
									<div className={formContext.step0Class}>
										<WaMembershipFormStep0
											errors={props.errors}
											touched={props.touched}
											setFieldValue={props.setFieldValue}
											values={props.values}
											setTouched={props.setTouched}
											formType={props.formType}
										/>
									</div>
									<div className={formContext.step1Class}>
										{formContext.stepImmediateNum == 1 && (
											<WaMembershipFormStep1
												errors={props.errors}
												touched={props.touched}
												setFieldValue={props.setFieldValue}
												values={props.values}
												formType={props.formType}
											/>
										)}
									</div>
									<div className={formContext.step2Class}>
										<WaMembershipFormStep2
											errors={props.errors}
											touched={props.touched}
											setFieldValue={props.setFieldValue}
											values={props.values}
											formType={props.formType}
											setTouched={props.setTouched}
										/>
									</div>
									<div className={formContext.step3Class}>
										<WaMembershipFormStep3
											errors={props.errors}
											touched={props.touched}
											setFieldValue={props.setFieldValue}
											values={props.values}
											formType={props.formType}
											submitForm={props.submitForm}
											contentId={props.contentId}
										/>
									</div>
									<div className={formContext.step4Class}>
										<ThankYouStep />
									</div>
								</div>
							</div>
							<div className="donProgressArea container">
								<div className="donSubmitErrorMessage">
									{formContext.submitError}
								</div>
								{props.formType !== MembershipFormType.Update &&
									formContext.stepNum < 4 && (
										<ProgressBar
											stepNumber={formContext.stepNum}
											colorTheme={formContext.colorTheme}
											stepAmount={4}
										/>
									)}
								<div className="donErrorMessages">
									{Object.keys(props.values).map((key, index) => {
										if (props.touched[key] && props.errors[key]) {
											return (
												<ErrorMessage
													errors={props.errors}
													touched={props.touched}
													colorTheme={formContext.colorTheme}
													name={key}
													key={index}
												/>
											);
										}
									})}
								</div>
								<div
									className={
										"donErrorMessages donOpposite" + formContext.colorTheme
									}
								>
									{formContext.busyState.busyError}
								</div>
								<div className="progress-bar-buttons">
									{formContext.stepNum > 0 && (
										<button
											className={`donButton ${formContext.colorTheme}ContSubButton ${formContext.backClass}`}
											type="button"
											style={{
												visibility:
													formContext.stepNum === 4
														? "hidden"
														: "visible",
											}}
											disabled={formContext.backDisabled}
											onClick={() => {
												if (formContext.stepNum > 0) {
													{
														formContext.setStepNum(
															formContext.stepNum - 1
														);
													}
												}
											}}
										>
											Back
										</button>
									)}
									{formContext.stepNum < 3 &&
										props.formType !== MembershipFormType.Update && (
											<button
												className={`donButton ${
													formContext.colorTheme
												}ContSubButton ${
													formContext.colorTheme + "HoverButton"
												}`}
												type="button"
												onClick={() =>
													continueOnClick(
														props.errors,
														props.touched,
														props.values,
														props.setFieldTouched,
														formContext.stepNum,
														formContext.setStepNum,
														props.formType
													)
												}
											>
												Next
											</button>
										)}
									{(formContext.stepNum === 3 ||
										props.formType === MembershipFormType.Update) && (
										<button
											className={`donButton ${
												formContext.colorTheme
											}ContSubButton ${
												props.formType === MembershipFormType.Update
													? formContext.colorTheme + "HoverButton"
													: formContext.submitClass
											}`}
											type="submit"
											disabled={
												props.formType === MembershipFormType.Update
													? false
													: formContext.submitDisabled
											}
										>
											{props.formType === MembershipFormType.Join && (
												<span style={{ whiteSpace: "nowrap" }}>
													Join Now!
												</span>
											)}
											{props.formType === MembershipFormType.Renew && (
												<span style={{ whiteSpace: "nowrap" }}>
													Renew Now!
												</span>
											)}
											{props.formType === MembershipFormType.Update && (
												<span style={{ whiteSpace: "nowrap" }}>
													Update Details
												</span>
											)}
										</button>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</Form>
		</LoadingOverlay>
	);
};
